export enum ActionItemCategoryType {
  PrimaryCategory = 1,
  SecondaryCategory,
}
